<template>
  <div
    class="fixed right-0 z-above-header p-4 duration"
    data-test-id="chat-fab"
    :style="{
      bottom: pxToRem(height),
      transform: hidden ? `translateY(calc(100% + ${pxToRem(height)}))` : 'translateY(0)',
    }"
  >
    <base-button
      :aria-label="$t.searchIconLabel"
      class="h-10 w-10 flex center b rounded-full bg-op-80 shadow-sm duration b-brand-1 bg-brand-1 c-white"
      @click="$chat.open({ eventLabel: $t.chatCta.chat, buttonLocation: 'floating-side-bar' })"
    >
      <vf-icon name="twinkle" size="md" />
    </base-button>
  </div>
</template>

<script lang="ts" setup>
const { $t, $chat, $feature } = useNuxtApp()
const route = useRoute()
const stickyState = useSticky()
const { y } = useScroll(window)
const hidden = ref(true)

watchEffect(() => {
  if (
    $feature.enableChatFabFirstScrollOnRoutes.some((pattern) => convertPatternToRegex(pattern).test(route.fullPath))
  ) {
    hidden.value = !y.value
  }
  else {
    hidden.value = false
  }
})

const badge = shallowRef<HTMLElement | null>(
  document.querySelector('.grecaptcha-badge'),
)

const { height } = useElementBounding(() =>
  stickyState.value.stickyProductCta
  || stickyState.value.cartSidebarStickyCtas
  || stickyState.value.cartStickyCtas
  || badge.value
)

const { stop } = useMutationObserver(
  document.body,
  () => {
    badge.value = document.querySelector('.grecaptcha-badge')

    if (badge.value)
      stop()
  },
  {
    childList: true,
    subtree: true,
  },
)
</script>
